<div *ngIf="isEmailClientTable">
  <nav class="navbar navbar-expand-lg navbar-light bg-light my-3">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  <!-- {{emailClientService?.outlookMessageType}} -->
    <div class="collapse navbar-collapse d-flex p-justify-end align-items-end" id="navbarSupportedContent">
      <form class="form-inline my-2 my-lg-0">
        <button class="btn btn-outline-secondary btn-sm my-2 my-sm-0 mr-1" (click)="createLabel()" type="button">Create Label</button>
        <button class="btn btn-outline-secondary btn-sm my-2 my-sm-0 mr-1" (click)="moveEmails()" type="button" *ngIf="selectedRows.length>0  && emailClientService?.outlookMessageType!='Drafts' && emailClientService?.outlookMessageType!='Deleted Items' && emailClientService?.outlookMessageType!='Sent Items'">Move Email</button>
        <button class="btn btn-outline-secondary btn-sm my-2 my-sm-0" (click)="deleteOutLookEmails()" type="button" *ngIf="selectedRows.length>0">Delete</button>
      </form>
    </div>
  </nav>
  <div>
    <!-- <pre>{{emailClientTableList|json}}</pre> -->
    <p-table
      class="pa-table"
      styleClass="p-datatable-striped"
      [value]="emailClientTableList"
      dataKey="id"
      selectionMode="multiple"
      [(selection)]="selectedRows"
    >
      <ng-template pTemplate="header" let-columns>
      <tr class="text-uppercase">
        <th class="grid_align" style="width: 4rem">
          <p-tableHeaderCheckbox class="p-1"></p-tableHeaderCheckbox>
        </th>
        <th class="grid_align">{{ headerActionType }}</th>
        <th class="grid_align">Subject</th>
        <th class="grid_align">Date</th>
      </tr>
      </ng-template>  
      <ng-template
        pTemplate="body"
        let-row
        let-expanded="expanded"
        let-rowIndex="rowIndex"
        let-columns="columns"
      >
        <tr #e [pSelectableRow]="row">
          <td  >
            <p-tableCheckbox  [pSelectableRow]="row"
                              [pSelectableRowIndex]="rowIndex" 
                              [value]="row">
            </p-tableCheckbox>
          </td>
          <td (click)="handleSelect(e, row)" [ngSwitch]="messageType">
              <span *ngIf="row.importance=='high'" title="High" style="color: #fff;" class="badge bg-danger mr-1">H</span>
              <span [ngClass]="{'font-weight-bold': !row.isRead}" *ngSwitchCase="'Inbox'">{{ row.from?.emailAddress?.name }}</span>
              <span [ngClass]="{'font-weight-bold': !row.isRead}" *ngSwitchCase="'Sent Items'">{{ row.toRecipients[0]?.emailAddress?.name }}</span>
              <span [ngClass]="{'font-weight-bold': !row.isRead}" *ngSwitchCase="'Drafts'">{{ row.toRecipients[0]?.emailAddress?.name }}</span>
              <span [ngClass]="{'font-weight-bold': !row.isRead}" *ngSwitchCase="'Deleted Items'">{{ row.toRecipients[0]?.emailAddress?.name }}</span>
              <span [ngClass]="{'font-weight-bold': !row.isRead}" *ngSwitchDefault>{{ row.from?.emailAddress?.name }}</span>
          </td>
          <td (click)="handleSelect(e, row)"><span [ngClass]="{'font-weight-bold': !row.isRead}">{{ row.subject }}</span></td>
          <td (click)="handleSelect(e, row)"><span [ngClass]="{'font-weight-bold': !row.isRead}">{{ row.sentDateTime | date: 'MM/dd/yyyy h:mm a' }}</span></td>
        </tr>
      </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="4">No Data</td>
            </tr>
        </ng-template>  
    </p-table>
    <div class="row float-right mt-5" *ngIf="emailClientService.isPaginationDisplay">
      <p-paginator styleClass="float-right" [rows]="pageSize" [first]="first" [totalRecords]="emailClientService.totalrecords" pageLinkSize="5"
      [rowsPerPageOptions]="[5,10,15]" [alwaysShow]="true" (onPageChange)="paginate($event)" #paginator></p-paginator>
    </div>
  </div>

<p-dialog  header="Create Label" [(visible)]="outlookLabelsModal" [style]="{width: '500px', minWidth: '200px'}"  [draggable]="false" [resizable]="false">
  <form [formGroup]="labelForm">
    <div class="row">
      <div class="col-12">
        <p class="label-cls required mb-2 mt-3">Label</p>
        <input class="input-align" type="text" maxlength="20" name="label" formControlName="label" />
          <small *ngIf="(labelForm.get('label').touched || submitted) && labelForm.get('label').errors" class="p-error">
          <span *ngIf="labelForm.get('label').errors['required']">Label is required.</span>
        </small>
      </div>
    </div>
    <div class="d-flex align-items-center mt-2 ml-3">
      <button type="button" (click)="onCreateLabel()" class="btn btn-sm btn-primary">Submit</button>
    </div>
  </form>
</p-dialog>

<p-dialog header="Move Emails" [(visible)]="outlookMoveModal" [style]="{width: '500px', minWidth: '200px'}"  [draggable]="false" [resizable]="false">
  <form [formGroup]="labelDropdownForm">
    <div class="row">
      <div class="col-12">
        <p class="label-cls required mb-2 mt-3">Select Label to move Email</p>
        <p-dropdown inputId="" appendTo="body" [options]="labelDropdownList" placeholder="Labels" optionLabel="displayName" optionValue="id" name="labeldropdown"
            formControlName="labeldropdown">
        </p-dropdown>
          <small *ngIf="(labelDropdownForm.get('labeldropdown').touched || submitted) && labelDropdownForm.get('labeldropdown').errors" class="p-error">
          <span *ngIf="labelDropdownForm.get('labeldropdown').errors['required']">Label is required.</span>
        </small>  
      </div>
    </div>
    <div class="d-flex flex-column ml-3 mt-2">
      <p class="text-warning" *ngIf="isMovingtoSameLabel">You are trying to move the email to the same folder/label</p>
      <button type="button" [disabled]="isMovingtoSameLabel || labelDropdownForm.invalid" (click)="onMove()" class="btn btn-sm btn-primary">Submit</button>
    </div>
  </form>
</p-dialog>

</div>
